import React, { useEffect, useState } from "react";
import {
  useTable,
  useRowSelect, useMountedLayoutEffect,
  useSortBy,
  usePagination,
  useFilters,
  useGlobalFilter
  // useAsyncDebounce,
} from "react-table";

import {
  Row, Col,
  Button, Spinner,
  Table,
  Label,
  Input,
  CustomInput,
  FormGroup,
  //Pagination ,
  //PaginationItem,
  //PaginationLink
} from "reactstrap";
import Pagination from "../pagination/Pagination";

import { matchSorter } from "match-sorter";
import "./table.css";

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter }
}) {
  return (
    <Input
      type="text"
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder="Search..."
      style={{
        fontSize: "10px"
      }}
    />
  );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
}

fuzzyTextFilterFn.autoRemove = (val) => !val;

const RTable = ({ columns, data, loading = true, showFilterSwitch = false, showSearch = false,
  showPagination = true, onSelectedRowsChange, selectedRows, paginationSize }) => {
  const [switchSearch, setSwitchSearch] = useState(showSearch);
  const toggleSwitchSearch = () => {
    setAllFilters([]);
    setSwitchSearch(!switchSearch);
  };
  const filterTypes = React.useMemo(
    () => ({
      fuzzyText: fuzzyTextFilterFn,
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      }
    }),
    []
  );

  const defaultColumn = React.useMemo(
    () => ({
      Filter: DefaultColumnFilter
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setAllFilters,
    selectedFlatRows,
    state: { pageIndex, pageSize, selectedRowIds }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: paginationSize || 10, selectedFlatRows: selectedRows || [], selectedRowIds: selectedRows || [] },
      defaultColumn,
      filterTypes
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  useMountedLayoutEffect(() => {
    onSelectedRowsChange && onSelectedRowsChange(selectedRowIds);
  }, [onSelectedRowsChange, selectedRowIds]);

  return (
    <>
      {showFilterSwitch &&
        <div>
          <span className="float-right ">
            <CustomInput
              checked={switchSearch}
              className="table-search-switch"
              type="switch"
              name="customSwitch"
              id="customSwitch"
              onClick={toggleSwitchSearch}
              label="Filter Data"
            />
          </span>
        </div>
      }
      <Table className="rtable" {...getTableProps()} size="sm" hover bordered striped responsive>
        <thead>
          {headerGroups.map((headerGroup, j) => (
            <>
              <tr key={j} className="theader" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, k) => (
                  <th key={k} {...column.getHeaderProps([column.getSortByToggleProps(), {
                    className: column.className,
                    style: column.style
                  }])}>
                    {column.render("Header")}
                    <span className="float-right">
                      {!column.notShowSortingDisplay ? (
                        column.isSorted ? (
                          column.isSortedDesc ? (
                            <i className="faCaretDown"></i>
                          ) : (
                            <i className="faCaretUp"></i>
                          )
                        ) : (
                          <i></i>
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
              {switchSearch ? (
                <tr>
                  {headerGroup.headers.map((column, index) => (
                    <td key={index} className="tfilter" style={{ padding: '0px' }}>
                      {column.canFilter ? (
                        <FormGroup className="mb-1">
                          {/*  <Label className="divFilter mb-0">
                            Filter {column.render("Header")} :
                          </Label> */}
                          {column.render("Filter")}
                        </FormGroup>
                      ) : null}
                    </td>
                  ))}
                </tr>
              ) : null
              }
            </>
          ))}
        </thead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan="10000" className="text-center">
                <Button variant="primary" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </Button>
              </td>
            </tr>
          </tbody>
        ) : (
          <>
            {page.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="10000" className="text-left">
                    No rows found
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody {...getTableBodyProps()}>
                {(showPagination ? page : rows).map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr key={i} {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps({
                              className: cell.column.className,
                              style: cell.column.style
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            )}
          </>
        )}
      </Table>
      {
        (page.length > 0 && showPagination) && (
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center fs--1">
              <p className="mb-0">
                <span className="d-none d-sm-inline-block me-2">{`${(pageIndex * pageSize) + 1} to ${(pageIndex * pageSize) + pageSize} of ${rows.length}`}</span>
              </p>
              <p className="mb-0 mx-2">Rows per page:</p>
              <Input type="select" size='sm' className="w-auto" value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}>
                {[10, 20, 30, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}

              </Input>
            </div>
            <div className="d-flex">
              <Pagination
                //className="pagination-bar"
                currentPage={pageIndex + 1}
                totalCount={rows.length}
                pageSize={pageSize}
                onPageChange={(p) => {
                  gotoPage(p - 1)
                }}
              />

            </div>
          </div>
        )
      }
    </>
  );
};
export default RTable